// extracted by mini-css-extract-plugin
module.exports = {"container":"shop_container__Z8jn_","title":"shop_title__ze6q7","noItem":"shop_noItem__gSqR_"};